import { PropsWithChildren } from "react";

import { ContentContainer } from "@/premium/themedComponents";

import styles from "./PageLayout.module.scss";

export const PageLayout = (props: PropsWithChildren & {showGradient?: boolean}) => {
  const { children } = props;

  return (
    <ContentContainer>
      <div className={styles["page-wrapper"]}>{children}</div>
    </ContentContainer>
  );
};
